export default {
    SELECT_NAVIGATION_OBJECT: "Выберите объект в навигации для его просмотра",
    NO_DATA_TEXT: "Здесь пока нет контента"
};
